import { render, staticRenderFns } from "./NewImport.vue?vue&type=template&id=6af57249&scoped=true&"
import script from "./NewImport.vue?vue&type=script&lang=js&"
export * from "./NewImport.vue?vue&type=script&lang=js&"
import style0 from "./NewImport.vue?vue&type=style&index=0&id=6af57249&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af57249",
  null
  
)

export default component.exports